import { render } from "./IndexingSettings.vue?vue&type=template&id=ed2ad76e&scoped=true"
import script from "./IndexingSettings.vue?vue&type=script&lang=js"
export * from "./IndexingSettings.vue?vue&type=script&lang=js"

import "./IndexingSettings.vue?vue&type=style&index=0&id=ed2ad76e&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/webshop/core-editor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed2ad76e"]])

export default __exports__